import clsx from 'clsx'
import styled from 'styled-components'
import FilterChip from 'LuxKit/Chips/FilterChip'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import SolidStarCircleIcon from 'LuxKit/Icons/solid/SolidStarCircleIcon'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import { rem } from 'polished'

const Pin = styled(FilterChip)`
  box-shadow: ${props => props.theme.shadow.bottom.small};
  && {
    border: 1px solid ${props => props.theme.palette.neutral.surface.darkBackground};
    min-width: ${rem(36)};
    height: ${rem(36)};
    padding: 0 ${rem(8)};
    gap: ${rem(4)};
    > svg { width: ${rem(20)}; height: ${rem(20)}; }
    &.icon-only { width: ${rem(36)}; gap: 0; > :not(svg) { display: none; } }
  }
  justify-content: center;
  &.flash {
    border-color: ${props => props.theme.palette.product.exclusive.background};
    color: ${props => props.theme.palette.neutral.surface.normalBackground};
    background: ${props => props.theme.palette.product.exclusive.background};
  }
  &&.seen:not(.active):not(.hovered):not(.saved) {
    background: ${props => props.theme.palette.neutral.surface.lightBackground};
    color: ${props => props.theme.palette.neutral.surface.normalContrast};
    &:not(.flash) {
      background: ${props => props.theme.palette.neutral.default.six};
      color: ${props => props.theme.palette.neutral.default.two};
    }
    &.flash {
      color: ${props => props.theme.palette.product.exclusive.background};
    }
  }
  &&.saved {
    background: ${props => props.theme.palette.neutral.surface.normalBackground};
    color: ${props => props.theme.palette.messaging.critical.normalForeground};
  }
  &&.hovered, &&.active {
    color: ${props => props.theme.palette.neutral.surface.darkContrast};
    background: ${props => props.theme.palette.neutral.surface.darkBackground};
  }
  &.unavailable { opacity: 0.6; }
`

interface Props {
  flash: boolean
  label?: string
  active: boolean
  hovered: boolean
  seen: boolean
  saved?: boolean
  unavailable: boolean
}

export default function SearchMapPin({ flash, label, active, hovered, seen, saved, unavailable }: Props) {
  return <Pin forwardedAs="span" size="large" className={clsx({ flash, active, hovered, seen, saved, unavailable, 'icon-only': !flash || !label || saved })} startIcon={saved ? <SolidHeartIcon size="S" /> : flash ? <SolidStarCircleIcon size="S" /> : <LineBedIcon size="S" />}>
    {flash && !saved ? label : undefined}
  </Pin>
}
